import { EventBus } from '../components/EventBus';

export default {
    EventBus,
    install(Vue, opts) {
        Vue.prototype.$eventBus = EventBus;
    }
}


// WEBPACK FOOTER //
// ./src/plugins/EventBusPlugin.js